// resourceUrlTypeConstants.js

export const API = 'api';
export const API_V2 = 'api-v2';
export const WATCH = 'watch';
export const PUBLIC = 'public';
export const RSS_FEED = 'rssFeed';
